import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

export default function CreateItemButton({ icon, onClick, text }) {
  return (
    <Box display="flex" justifyContent="end" mb={2} width="100%">
      <Button
        color="secondary"
        onClick={onClick}
        size="large"
        startIcon={icon}
        variant="text"
      >
        {text}
      </Button>
    </Box>
  );
}
